import { render, staticRenderFns } from "./Pelanggan.vue?vue&type=template&id=b7dc1c6a"
import script from "./Pelanggan.vue?vue&type=script&lang=js"
export * from "./Pelanggan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports